import { lazy } from 'react';

// ==================== ONBOARD (PUBLIC) ====================
export const Login = lazy(() =>
  import('@/Pages/Onboard/Login/login').then(m => ({ default: m.Login })),
);

export const ForgotPassword = lazy(() =>
  import('@/Pages/Onboard/Forgot/ForgotPassword').then(m => ({
    default: m.ForgotPassword,
  })),
);

export const CreatePassword = lazy(() =>
  import('@/Pages/Onboard/CreatePassword/CreatePassword').then(m => ({
    default: m.CreatePassword,
  })),
);

export const Signup = lazy(() =>
  import('@/Pages/Onboard/SignUp/signUp').then(m => ({ default: m.Signup })),
);

export const TwoFactorSetup = lazy(() =>
  import('@/Pages/Onboard/TwoFactor/TwoFactor').then(m => ({
    default: m.TwoFactor,
  })),
);

// ==================== AUTHENTICATED ====================

// API
export const api = {
  list: lazy(() => import('@/Pages/API/API').then(m => ({ default: m.API }))),
};

// Reports
export const reports = {
  list: lazy(() => import('@/Pages/Reports/Reports').then(m => ({ default: m.Reports }))),
  create: lazy(() =>
    import('@/Pages/Reports/Content/CreateReport/CreateReport').then(m => ({
      default: m.CreateReportContent,
    })),
  ),
};

// Settings - Estrutura nested
export const settings = {
  overview: lazy(() =>
    import('@/Pages/Settings/Overview/overview').then(m => ({
      default: m.Overview,
    })),
  ),
  myAccount: lazy(() =>
    import('@/Pages/Settings/MyAccount/myAccount').then(m => ({
      default: m.MyAccount,
    })),
  ),
  loginSecurity: lazy(() =>
    import('@/Pages/Settings/LoginSecurity/loginSecurity').then(m => ({
      default: m.LoginSecurity,
    })),
  ),
  users: lazy(() =>
    import('@/Pages/Settings/Users/Users').then(m => ({
      default: m.Users,
    })),
  ),
  audit: lazy(() =>
    import('@/Pages/Settings/Audit/Audit').then(m => ({
      default: m.Audit,
    })),
  ),
};

// Developer
export const developer = {
  sdk: lazy(() =>
    import('@/Pages/Developer/SDK/DeveloperSDK').then(m => ({
      default: m.DeveloperSDK,
    })),
  ),
  batch: lazy(() => import('@/Pages/Developer/Batch/Batch').then(m => ({ default: m.Batch }))),
  batchCreate: lazy(() =>
    import('@/Pages/Developer/Batch/Content/CreateBatch/CreateBatch').then(m => ({
      default: m.CreateBatchContent,
    })),
  ),
  credentials: lazy(() =>
    import('@/Pages/Developer/Credentials/Credentials').then(m => ({ default: m.Credentials })),
  ),
  credentialsCreate: lazy(() =>
    import('@/Pages/Developer/Credentials/Content/CreateCredential/CreateCredential').then(m => ({
      default: m.CreateCredentialContent,
    })),
  ),
};

// Groups
export const groups = {
  list: lazy(() =>
    import('@/Pages/Groups/ChooseGroup/ChooseGroup').then(m => ({
      default: m.ChooseGroup,
    })),
  ),
};

// Device Blocks
export const deviceBlocks = {
  list: lazy(() =>
    import('@/Pages/DeviceBlocks/DeviceBlocks').then(m => ({
      default: m.DeviceBlocks,
    })),
  ),
};

// Tags Management
export const tagsManagement = {
  list: lazy(() =>
    import('@/Pages/TagsManagement/TagsManagement').then(m => ({
      default: m.TagsManagement,
    })),
  ),
};

// Impersonate
export const Impersonate = lazy(() =>
  import('@/Pages/Impersonate').then(m => ({ default: m.Impersonate })),
);

// ==================== FALLBACK ====================
export const BlockedScreenPage = lazy(() =>
  import('@/Pages/BlockedScreen').then(m => ({ default: m.BlockedScreenPage })),
);

export const NotFound = lazy(() =>
  import('@/Pages/NotFound/NotFound').then(m => ({ default: m.NotFound })),
);
